import React, { useState } from "react";
import { Option } from "react-select/lib/filters";
import { useTranslation } from "react-i18next";
import useGetModalityOptions from "@modules/shared/selectors/hooks/useGetModalityOptions";
import AdvanceSelector from "../advance-selector";

interface AdvancedModalitySelectorProps {
  onChange?: (option: Option) => void;
  scenario: string;
  modalityOption?: Option;
}

const AdvancedModalitySelector = ({
  scenario,
  onChange,
  modalityOption,
}: AdvancedModalitySelectorProps) => {
  const [value, setValue] = useState(modalityOption);

  const { loadOptions } = useGetModalityOptions({
    scenario,
  });

  const { t } = useTranslation();

  return (
    <AdvanceSelector
      isPaginated
      dimension={t("advanced-search.instructor.forms.select-wrapper.mode.label")}
      selectPlaceholder={t("advanced-search.instructor.forms.select-wrapper.mode.placeholder")}
      loadOptions={loadOptions}
      value={value}
      onChange={option => {
        setValue(option);
        onChange?.(option);
      }}
      notShowLabel
    />
  );
};

export default AdvancedModalitySelector;
